
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/create/[...voice]",
      function () {
        return require("private-next-pages/create/[...voice].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/create/[...voice]"])
      });
    }
  